import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol,[_c('h1',[_vm._v("Integrations")]),(_vm.currentCompany.isHubSpotIntegrated)?_c(VBtn,{attrs:{"disabled":""}},[_vm._v("HubSpot Connected")]):_c(VBtn,{on:{"click":function($event){return _vm.goToHubSpotConnect()}}},[_vm._v("Connect to HubSpot")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }